module.exports = require("/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/react/index.js");;